/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ARGOS_PROD_FRONTEND_DOMAIN, ARGOS_TEST_FRONTEND_DOMAIN} from "../../../constants/globalVariables";

const getSlotUsingUrl = () => {
  // return 'PROD'
  // return 'RELEASE' // uncomment if using release db locally
  const url = window.location.href
  if (url.includes('localhost') || url.includes(ARGOS_TEST_FRONTEND_DOMAIN)) {
    return 'TEST'
  } else if(url.includes(ARGOS_PROD_FRONTEND_DOMAIN)){
    return 'PROD'
  } else {
    return 'RELEASE'
  }
}

const getHubName = (suffix: string) => {
  const slot = getSlotUsingUrl()
  let name = `${slot}_${suffix}`
  // replace all - characters with _
  name = name.replace(/-/g, '_')
  return name
}

export {
  getSlotUsingUrl,
  getHubName
}